var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-datepicker',{staticClass:"myInput form-control",attrs:{"placeholder":_vm.placeholder,"min":_vm.minDate,"max":_vm.maxDate}})}
var staticRenderFns = []

export { render, staticRenderFns }